import USERS_SNAPSHOT from '../../../../rental-portal-mock-data/users.json'
import VIEWING_UPDATES_SNAPSHOT from '../../../../rental-portal-mock-data/viewing-updates.json'
import { HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../constants/api'
import { EMPTY_LIST } from '../../../constants/common'
import {
  RENTAL_PORTAL_MOCK_LATENCY,
  RENTAL_PORTAL_MOCK_STATE,
} from '../../../constants/rentalPortalMockState'
import { MANAGER_USER_ROLE } from '../../../constants/user'
import { hasRentalPortalMockState } from '../../../utils/rentalPortalMockState'

const MOCK_VIEWING_UPDATES_READ_LATENCY = 300

const MOCK_VIEWING_UPDATES_READ_ERROR = {
  response: { status: HTTP_STATUS_INTERNAL_SERVER_ERROR },
}

function toMockViewingUpdateActor(user) {
  return {
    avatar: null,
    avatar_color: user.avatar_color,
    deleted: user.is_archived,
    id: user.id,
    is_system: false,
    name: user.first_name,
    role: MANAGER_USER_ROLE,
    surname: user.last_name,
  }
}

const MOCK_VIEWING_UPDATE_ACTOR_BY_ID = new Map(
  USERS_SNAPSHOT.map(user => [user.id, toMockViewingUpdateActor(user)])
)

const MOCK_VIEWING_UPDATE_SYSTEM_ACTOR = {
  avatar: null,
  avatar_color: null,
  deleted: false,
  id: null,
  is_system: true,
  name: null,
  role: null,
  surname: null,
}

function getMockViewingUpdateActor(actorId) {
  return actorId == null
    ? MOCK_VIEWING_UPDATE_SYSTEM_ACTOR
    : (MOCK_VIEWING_UPDATE_ACTOR_BY_ID.get(actorId) ?? null)
}

function toServedMockViewingUpdate({
  action,
  actor_id: actorId,
  data,
  event_dt: eventDt,
  id,
}) {
  return {
    action,
    data,
    event_dt: eventDt,
    id,
    initiated_by: getMockViewingUpdateActor(actorId),
  }
}

function toMockViewingUpdatesById(events) {
  return events.reduce((acc, event) => {
    const served = acc.get(event.viewing_id) ?? EMPTY_LIST

    return acc.set(event.viewing_id, [
      toServedMockViewingUpdate(event),
      ...served,
    ])
  }, new Map())
}

const MOCK_VIEWING_UPDATES_BY_ID = toMockViewingUpdatesById(
  VIEWING_UPDATES_SNAPSHOT
)

function withMockLatency() {
  const delay = hasRentalPortalMockState(RENTAL_PORTAL_MOCK_STATE.loading)
    ? RENTAL_PORTAL_MOCK_LATENCY
    : MOCK_VIEWING_UPDATES_READ_LATENCY

  return new Promise(resolve => {
    setTimeout(resolve, delay)
  })
}

export function getMockViewingLogEvents({
  page,
  page_size: pageSize,
  viewing_id: viewingId,
}) {
  return withMockLatency().then(() => {
    if (hasRentalPortalMockState(RENTAL_PORTAL_MOCK_STATE.error)) {
      return Promise.reject(MOCK_VIEWING_UPDATES_READ_ERROR)
    }

    const events = hasRentalPortalMockState(RENTAL_PORTAL_MOCK_STATE.empty)
      ? EMPTY_LIST
      : (MOCK_VIEWING_UPDATES_BY_ID.get(Number(viewingId)) ?? EMPTY_LIST)

    const pageCount = Math.ceil(events.length / pageSize)
    const currentPage = Math.min(page, Math.max(pageCount, 1))
    const firstIndex = (currentPage - 1) * pageSize

    return {
      data: {
        pagination: {
          page: currentPage,
          page_count: pageCount,
          total: events.length,
        },
        results: {
          objects: events.slice(firstIndex, firstIndex + pageSize),
        },
      },
    }
  })
}
